/* ============================================================
   LOi Brasil — Scripts customizados consolidados (v1.0)
   Arquivo: assets/loi-custom.js
   Carregado com "defer" a partir do theme.liquid.
   Conteúdo (na ordem):
     1. UTMs -> atributos do carrinho
     2. Remoção do botão PIX órfão (#scala-button)  [DESINSTALAR O APP!]
     3. Badges PIX + entrega na PDP
     4. Reposicionamento de badges/estoque acima do título (PDP)
     5. Swatches de cor e pills de variantes (PDP)
     6. Calculadora de frete por CEP (PDP)
     7. Reposicionamento do widget Tolstoy (PDP)
     8. Correção da galeria de imagens / tiny-slider (PDP)
     9. Selo Reclame Aqui -> rodapé
   ============================================================ */
(function () {
  'use strict';

  var IS_PDP = window.location.pathname.indexOf('/products/') !== -1;

  /* ------------------------------------------------------------
     1. UTMs -> atributos do carrinho
     Melhoria: roda só 1x por sessão (antes disparava um POST
     /cart/update.js em CADA pageview com UTM).
  ------------------------------------------------------------ */
  function captureUtms() {
    try {
      if (sessionStorage.getItem('loiUtmsSaved')) return;
      var params = new URLSearchParams(window.location.search);
      var utmSource = params.get('utm_source');
      if (!utmSource) return;

      var attrs = {
        '_utm_source': utmSource,
        '_utm_medium': params.get('utm_medium') || '',
        '_utm_campaign': params.get('utm_campaign') || '',
        '_utm_content': params.get('utm_content') || ''
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () {
        sessionStorage.setItem('loiUtmsSaved', '1');
      }).catch(function () { /* silencioso */ });
    } catch (e) { /* navegadores sem sessionStorage */ }
  }

  /* ------------------------------------------------------------
     2. Remoção do botão PIX órfão (#scala-button)
     ATENÇÃO: isto é um curativo. O correto é DESINSTALAR o app
     que injeta esse botão (Settings -> Apps and sales channels).
     Melhoria: o observer se desliga sozinho após 10s
     (o original observava o DOM para sempre).
  ------------------------------------------------------------ */
  function removeOrphanPixButton() {
    function tryRemove() {
      var el = document.getElementById('scala-button');
      if (el) {
        el.remove();
        obs.disconnect();
        return true;
      }
      return false;
    }
    var obs = new MutationObserver(tryRemove);
    if (!tryRemove()) {
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obs.disconnect(); }, 10000);
    }
  }

  /* ------------------------------------------------------------
     3. Badges PIX + entrega na PDP
     Texto de entrega ajustado: "Entrega imediata" prometia para
     todo o Brasil (risco CDC). Agora promete só o que cumprimos.
  ------------------------------------------------------------ */
  var PRICE_SELECTOR =
    '[id^="pdp-details_"] .product-details_price .simple_price .price-sale.js-price, ' +
    '[id^="pdp-details_"] .product-details_price .simple_price .price.js-price';

  function upsertBadges() {
    var priceEl = document.querySelector(PRICE_SELECTOR);
    if (!priceEl) return false;

    var wrap = priceEl.parentElement.querySelector('.price-badges');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'price-badges';
      priceEl.insertAdjacentElement('afterend', wrap);
    }

    if (!wrap.querySelector('.pix-badge')) {
      var pix = document.createElement('span');
      pix.className = 'pix-badge';
      pix.textContent = '10% OFF no PIX';
      wrap.appendChild(pix);
    }

    if (!wrap.querySelector('.delivery-badge')) {
      var del = document.createElement('span');
      del.className = 'delivery-badge';
      del.textContent = 'Mesmo dia em São Paulo';
      wrap.appendChild(del);
    }
    return true;
  }

  function initBadges() {
    if (upsertBadges()) { moveBadgesAboveTitle(); return; }
    var obs = new MutationObserver(function () {
      if (upsertBadges()) {
        moveBadgesAboveTitle();
        obs.disconnect();
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }

  /* ------------------------------------------------------------
     4. Badges + tag de estoque acima do título do produto
  ------------------------------------------------------------ */
  function moveBadgesAboveTitle() {
    var badges = document.querySelector('.price-badges');
    var title = document.querySelector('.product-info_title');
    var stockTag = document.querySelector('.loi-stock-tag');

    if (badges && title) title.parentElement.insertBefore(badges, title);
    if (stockTag && title) title.parentElement.insertBefore(stockTag, title);
  }

  /* ------------------------------------------------------------
     5. Swatches de cor + pills de variantes
  ------------------------------------------------------------ */
  var colorMap = {
    'preto': '#1E2330', 'black': '#1E2330',
    'vermelho': '#C0392B', 'red': '#C0392B',
    'branco': '#FFFFFF', 'white': '#FFFFFF',
    'azul': '#2980B9', 'blue': '#2980B9',
    'verde': '#27AE60', 'green': '#27AE60',
    'amarelo': '#F1C40F', 'yellow': '#F1C40F',
    'rosa': '#E91E8C', 'pink': '#E91E8C',
    'cinza': '#95A5A6', 'gray': '#95A5A6', 'grey': '#95A5A6',
    'laranja': '#E67E22', 'orange': '#E67E22',
    'roxo': '#8E44AD', 'purple': '#8E44AD',
    'dourado': '#C9A84C', 'gold': '#C9A84C',
    'prata': '#BDC3C7', 'silver': '#BDC3C7'
  };
  var colorTitles = ['cor', 'color', 'colour', 'cores'];

  function buildVariants() {
    var groups = document.querySelectorAll('.swatch-group');
    if (!groups.length) return false;

    groups.forEach(function (group) {
      if (group.dataset.loiBuilt) return;

      var titleEl = group.querySelector('.swatch-group_title');
      var titleText = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
      var select = group.querySelector('select.swatch-select');
      if (!select) return;

      var options = Array.prototype.slice.call(select.options);
      var isColor = colorTitles.indexOf(titleText) !== -1;

      if (isColor) {
        var container = document.createElement('div');
        container.className = 'loi-color-swatches';

        options.forEach(function (opt) {
          var val = opt.value.toLowerCase().trim();
          var color = colorMap[val] || '#CCCCCC';

          var circle = document.createElement('button');
          circle.className = 'loi-swatch-circle' + (opt.selected ? ' active' : '');
          circle.style.cssText = 'background:' + color + ';';
          if (color === '#FFFFFF') circle.classList.add('white-swatch');
          circle.title = opt.value;
          circle.type = 'button';

          circle.addEventListener('click', function () {
            select.value = opt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            container.querySelectorAll('.loi-swatch-circle').forEach(function (c) {
              c.classList.remove('active');
            });
            circle.classList.add('active');
          });

          container.appendChild(circle);
        });

        var inner = group.querySelector('.swatch-group_inner');
        if (inner) {
          select.style.display = 'none';
          var svg = inner.querySelector('svg');
          if (svg) svg.style.display = 'none';
          inner.appendChild(container);
        }
      } else {
        var pillRow = document.createElement('div');
        pillRow.className = 'loi-pill-row';
        pillRow.style.cssText = 'display:flex;gap:8px;flex-wrap:wrap;';

        options.forEach(function (opt) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = opt.value;
          btn.style.cssText = 'padding:8px 18px;border:1.5px solid ' +
            (opt.selected ? '#1E2330' : '#E2E8F0') + ';border-radius:50px;background:' +
            (opt.selected ? '#1E2330' : '#F8F9FA') + ';color:' +
            (opt.selected ? '#fff' : '#5A6171') +
            ';font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;transition:all 0.15s;white-space:nowrap;';

          btn.addEventListener('click', function () {
            select.value = opt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            pillRow.querySelectorAll('button').forEach(function (b) {
              b.style.background = '#F8F9FA';
              b.style.color = '#5A6171';
              b.style.borderColor = '#E2E8F0';
            });
            btn.style.background = '#1E2330';
            btn.style.color = '#fff';
            btn.style.borderColor = '#1E2330';
          });

          pillRow.appendChild(btn);
        });

        var inner2 = group.querySelector('.swatch-group_inner');
        if (inner2) {
          select.style.display = 'none';
          var svg2 = inner2.querySelector('svg');
          if (svg2) svg2.style.display = 'none';
          inner2.appendChild(pillRow);
        }
      }

      group.dataset.loiBuilt = 'true';
    });

    return true;
  }

  /* ------------------------------------------------------------
     6. Calculadora de frete por CEP (LOI FRETE v3.1)
     Removidos os console.log de debug que estavam em produção.
  ------------------------------------------------------------ */
  function initFrete() {
    var W = 'https://loi-frete.dan-074.workers.dev';

    function isSP(c) { var n = parseInt(c, 10); return n >= 1000000 && n <= 9999999; }
    function brl(v) { return 'R$ ' + parseFloat(v).toFixed(2).replace('.', ','); }
    function icon(n) {
      n = n.toLowerCase();
      if (n.indexOf('pida') !== -1 || n.indexOf('edex') !== -1) return '\uD83C\uDFC3';
      if (n.indexOf('oggi') !== -1) return '\uD83D\uDEF5';
      if (n.indexOf('adlog') !== -1) return '\uD83D\uDE9A';
      return '\uD83D\uDCE6';
    }
    function mask(v) {
      v = v.replace(/\D/g, '').slice(0, 8);
      return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
    }
    function priceHTML(val) {
      var f = parseFloat(val);
      return f === 0
        ? '<div class="loi-cep-calc__option-price gratis">GR\u00C1TIS</div>'
        : '<div class="loi-cep-calc__option-price">' + brl(val) + '</div>';
    }

    var anchor = document.querySelector('.loi-trust-badges-mid');
    if (!anchor || document.querySelector('.loi-cep-calc')) return;

    anchor.insertAdjacentHTML('beforebegin',
      '<div class="loi-cep-calc">' +
        '<span class="loi-cep-calc__title">\uD83D\uDE9A Calcular prazo e frete</span>' +
        '<div class="loi-cep-calc__row">' +
          '<input class="loi-cep-calc__input" id="loiCI" type="tel" placeholder="Digite seu CEP (ex: 09210-180)" maxlength="9">' +
          '<button class="loi-cep-calc__btn" id="loiCB">Calcular</button>' +
        '</div>' +
        '<div id="loiCR"></div>' +
        '<span class="loi-cep-calc__link"><a href="https://buscacepinter.correios.com.br" target="_blank" rel="noopener">N\u00E3o sei meu CEP</a></span>' +
      '</div>');

    var inp = document.getElementById('loiCI');
    var btn = document.getElementById('loiCB');
    var res = document.getElementById('loiCR');

    inp.oninput = function () { this.value = mask(this.value); };
    inp.onkeydown = function (e) { if (e.key === 'Enter') btn.click(); };

    btn.onclick = function () {
      var cep = inp.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        res.innerHTML = '<p class="loi-cep-calc__error">CEP inv\u00E1lido.</p>';
        return;
      }
      btn.disabled = true;
      btn.textContent = '...';
      res.innerHTML = '<div class="loi-cep-calc__loading">Consultando transportadoras...</div>';

      fetch('https://viacep.com.br/ws/' + cep + '/json/')
        .then(function (vr) { return vr.json(); })
        .then(function (vd) {
          if (vd.erro) {
            res.innerHTML = '<p class="loi-cep-calc__error">CEP n\u00E3o encontrado.</p>';
            btn.disabled = false;
            btn.textContent = 'Calcular';
            return null;
          }
          var price = 100;
          try {
            var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
            if (m && m.product && m.product.price) price = m.product.price / 100;
          } catch (x) {}

          return fetch(W, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              cepDestino: cep, peso: 1, altura: 16, largura: 20, comprimento: 40, valor: price
            })
          })
            .then(function (fr) { return fr.json(); })
            .then(function (fd) {
              btn.disabled = false;
              btn.textContent = 'Calcular';

              var svs = (fd.ShippingSevicesArray || [])
                .filter(function (s) {
                  if (s.Error || s.ShippingPrice === undefined) return false;
                  var carrier = (s.Carrier || '').toLowerCase();
                  if (carrier.indexOf('retirada') !== -1) return false;
                  return true;
                })
                .sort(function (a, b) {
                  return parseFloat(a.ShippingPrice) - parseFloat(b.ShippingPrice);
                });

              var h = '<div class="loi-cep-calc__results">';
              if (isSP(cep)) {
                h += '<div class="loi-cep-calc__option destaque">' +
                  '<div class="loi-cep-calc__option-left">' +
                  '<span class="loi-cep-calc__option-icon">\uD83D\uDE80</span>' +
                  '<div><div class="loi-cep-calc__option-name">Entrega Hoje <span class="loi-cep-calc__badge-mesmoDia">MESMO DIA</span></div>' +
                  '<div class="loi-cep-calc__option-prazo">Pedidos at\u00E9 12h \u2014 ' + vd.localidade + '</div></div></div>' +
                  '<div class="loi-cep-calc__option-price gratis">GR\u00C1TIS</div></div>';
              }
              if (!svs.length) {
                h += '<p class="loi-cep-calc__error" style="margin-top:8px">Sem op\u00E7\u00F5es para este CEP.</p>';
              } else {
                svs.forEach(function (s) {
                  var n = (s.ServiceDescription || s.Carrier || '').split('|')[0].trim();
                  var p = parseInt(s.DeliveryTime, 10) || 0;
                  h += '<div class="loi-cep-calc__option">' +
                    '<div class="loi-cep-calc__option-left">' +
                    '<span class="loi-cep-calc__option-icon">' + icon(n + s.Carrier) + '</span>' +
                    '<div><div class="loi-cep-calc__option-name">' + n + ' \u2014 ' + s.Carrier + '</div>' +
                    '<div class="loi-cep-calc__option-prazo">' +
                    (p === 1 ? '1 dia \u00FAtil' : p + ' dias \u00FAteis') +
                    ' \u2014 ' + vd.localidade + '/' + vd.uf + '</div></div></div>' +
                    priceHTML(s.ShippingPrice) + '</div>';
                });
              }
              h += '</div>';
              res.innerHTML = h;
            });
        })
        .catch(function () {
          res.innerHTML = '<p class="loi-cep-calc__error">Erro ao consultar. Tente novamente.</p>';
          btn.disabled = false;
          btn.textContent = 'Calcular';
        });
    };
  }

  /* ------------------------------------------------------------
     7. Reposiciona o widget Tolstoy dentro da galeria da PDP
  ------------------------------------------------------------ */
  function moveTolstoy() {
    if (document.querySelector('.loi-tolstoy-pdp')) return;
    var ts = document.querySelector('tolstoy-stories');
    var media = document.querySelector('.product-info_media');
    if (!ts || !media) return;
    var wrapper = document.createElement('div');
    wrapper.className = 'loi-tolstoy-pdp';
    wrapper.appendChild(ts);
    media.appendChild(wrapper);
  }

  /* ------------------------------------------------------------
     8. Correção da galeria (tiny-slider) na PDP
  ------------------------------------------------------------ */
  function fixGallery() {
    var mainComp = document.querySelector('slider-component#product-media-main');
    var thumbComp = document.querySelector('slider-component#product-media-thumnails');
    if (!mainComp || !thumbComp) return;

    if (!mainComp.slider) { try { mainComp.init(); } catch (e) {} }
    if (!thumbComp.slider) { try { thumbComp.init(); } catch (e) {} }
    if (!mainComp.slider) return;

    var tnsCtrl = mainComp.querySelector('.tns-controls');
    if (tnsCtrl) tnsCtrl.style.cssText = 'display:none!important';

    var prevBtn = mainComp.querySelector('.slider-prev-button');
    var nextBtn = mainComp.querySelector('.slider-next-button');

    if (prevBtn && !prevBtn.dataset.loi) {
      prevBtn.dataset.loi = '1';
      prevBtn.style.cssText = 'z-index:20!important;position:absolute!important;';
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        mainComp.slider.goTo('prev');
        if (thumbComp.slider) thumbComp.slider.goTo('prev');
      });
    }
    if (nextBtn && !nextBtn.dataset.loi) {
      nextBtn.dataset.loi = '1';
      nextBtn.style.cssText = 'z-index:20!important;position:absolute!important;';
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        mainComp.slider.goTo('next');
        if (thumbComp.slider) thumbComp.slider.goTo('next');
      });
    }

    thumbComp.querySelectorAll('.media-item').forEach(function (item, idx) {
      if (item.dataset.loi) return;
      item.dataset.loi = '1';
      item.style.cursor = 'pointer';
      item.addEventListener('click', function () {
        mainComp.slider.goTo(idx);
      });
    });
  }

  /* ------------------------------------------------------------
     9. Selo Reclame Aqui -> rodapé
  ------------------------------------------------------------ */
  function moveReclameAquiSeal() {
    var seal = document.getElementById('ra-verified-seal');
    var footer = document.querySelector('.block-reclame-aqui-wrapper');
    if (seal && footer) {
      seal.style.display = 'block';
      footer.appendChild(seal);
    }
  }

  /* ------------------------------------------------------------
     Bootstrap
     (arquivo carrega com defer => DOM já está pronto,
     mas mantemos os fallbacks de "load" para widgets de apps
     que chegam depois, como o Tolstoy)
  ------------------------------------------------------------ */
  captureUtms();
  removeOrphanPixButton();

  if (IS_PDP) {
    initBadges();
    buildVariants();
    initFrete();
    fixGallery();
  }

  window.addEventListener('load', function () {
    if (IS_PDP) {
      buildVariants();
      setTimeout(buildVariants, 500);
      fixGallery();
      setTimeout(fixGallery, 500);
      setTimeout(fixGallery, 1500);
      setTimeout(moveTolstoy, 1500);
      initFrete();
      setTimeout(initFrete, 1000);
    }
    moveReclameAquiSeal();
  });
})();
